import cta from '~/components/atoms/a-ctas/a-cta-v2.data'
export default {
  eyebrow: 'Wren',
  heading: 'Wren Rap',
  image: {
    alt: 'Image showing a singer rapping about Wren',
    filename:
      '//a.storyblok.com/f/46530/1480x833/6395ff7d46/01-hero-wren-001.png',
  },
  image2: {
    alt: 'Image showing a singer rapping about Wren',
    filename:
      '//a.storyblok.com/f/46530/1480x833/6395ff7d46/01-hero-wren-001.png',
  },
  cta: [
    {
      ...cta,
      copy: 'View case study',
      href: {
        url: '/case-study',
        cached_url: '/case-study',
      },
      type: 'primary',
    },
    {
      ...cta,
      copy: 'View all work',
      href: {
        url: '/case-study',
        cached_url: '/case-study',
      },
      type: 'secondary',
    },
  ],
  component: 'm-slide-v2',
}
